import { IS_SERVER } from './ssr';
import { setSigningOut } from './useMe';

/**
 * Marks the document for a deliberate sign-out / account-deletion transition.
 *
 * `setSigningOut(true)` tells `api.ts` to swallow the auth (401) and not-found
 * (404) toasts that in-flight or re-fired authed requests throw once the token
 * is cleared but before the still-mounted page unmounts (e.g. a `membership/me`
 * refetch that 404s because the account is gone). `data-signing-out` on `<html>`
 * keeps the RAS loader (see `pages/+config.ts`) hidden so it never flashes
 * during the client nav to `/signin`.
 *
 * Shared by the `/signout` page and the account-deletion flow so both get the
 * same calm, toast-free transition. Always pair with `endSignOutTransition`.
 */
export function beginSignOutTransition(): void {
  setSigningOut(true);

  if (!IS_SERVER) {
    document.documentElement.setAttribute('data-signing-out', '');
  }
}

export function endSignOutTransition(): void {
  setSigningOut(false);

  if (!IS_SERVER) {
    document.documentElement.removeAttribute('data-signing-out');
  }
}
